module.exports = __webpack_public_path__ + "static/img/Cadman.af812c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Cadman.jpg
// module id = 940l
// module chunks = 0